import { Tag } from "antd";
import { CORP_CLAIM_STATUS } from "../services/corpClaimPortalService";

const DOT_COLORS = {
  default: "#8AA196", blue: "#1677ff", gold: "#d48806", orange: "#fa8c16",
  purple: "#722ed1", green: "#189F6B", red: "#cf1322", cyan: "#13a8a8", success: "#189F6B",
};

/** A status pill with a leading colour dot — reused on the list and detail pages. */
const StatusTag = ({ status }) => {
  const s = CORP_CLAIM_STATUS[status] || { label: status, color: "default" };
  return (
    <Tag color={s.color} style={{ display: "inline-flex", alignItems: "center", gap: 6, fontWeight: 500 }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: DOT_COLORS[s.color] || DOT_COLORS.default, display: "inline-block" }} />
      {s.label}
    </Tag>
  );
};

export default StatusTag;
